import { useState } from "react";

import { AppLayout } from "@/components/AppLayout";
import { PerformancePage } from "./PerformancePage";

export function PerformanceRoute() {
  const [editing, setEditing] = useState(false);
  return (
    <AppLayout>
      <PerformancePage editing={editing} onEditingChange={setEditing} />
    </AppLayout>
  );
}
